"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponteranica": {
    "f48777ba": [{
      "hkey": "6b6be10f",
      "slug": "castello-della-moretta",
      "name": "Castello della Moretta",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "6b6be10f",
      "slug": "castello-della-moretta",
      "name": "Castello della Moretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "770ffcf0": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "skipSearch": false
    }],
    "costa-garatti": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2be7bf23": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fustina": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponteranica"
    }],
    "e6094131": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "localita-ponteranica-alta": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a6c96e28": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "skipSearch": false
    }],
    "pasinetti": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25b6f05d": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "petos": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponteranica"
    }],
    "4bd20b9e": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "skipSearch": false
    }],
    "pontesecco": [{
      "hkey": "baa821e5",
      "slug": "ponteranica",
      "name": "Ponteranica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c3443ec": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ramera": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponteranica"
    }],
    "b583d261": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "valbona": [{
      "hkey": "c49974fc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponteranica"
    }]
  }
};
exports["default"] = _default;